import baseAPI from './api';
import baseURLs from '../configs/baseURLs';


//  criando uma classe gerica para ProdutoServices, para reutilizar o codigo toda vez que eu precisar chamar o end poit parametro
class ParametroServices {
    constructor (){
        this.api = baseAPI(baseURLs.API_PARAMETRO);
        this.apiLoadinfDfe = baseAPI(baseURLs.API_LOANDING_DFE);
        this.api_parametar_geral = baseAPI(baseURLs.API_PARAMETER_SISTEFOOD_GENERAL);
    }
    
    async #genericMethod (api, endPoint, json) {
        const result = await api.post(endPoint, json);
        return result.data;
    }

    async getAllParameter(cnpj) {  
        return await this.#genericMethod(this.api, 'carregarParametroSistefoodGeral', cnpj)
    }
    
    async getAll(cnpj) {  
        const result = await this.api.post('carregarParametro',  cnpj );
        return result.data;
    }

    async add(parametroModel) {
        const result = await this.api.post('salvarParametro', parametroModel);
        return result.data;
    }

    async getEstablishmentDice(establishmentDice) {
        const result = await this.api.post('carregarParametroSistefoodDadosEmpresa', establishmentDice);
        return result.data;
    }

    async saveEstablishmentDice(establishmentDice) {
        const result = await this.api.post('salvarParametroSistefoodDadosEmpresa', establishmentDice);
        return result.data;
    }

    async getDelivery(establishmentDice) {
        const result = await this.api.post('carregarParametroSistefoodDelivery', establishmentDice);
        return result.data;
    }

    async saveDelivery(establishmentDice) {
        const result = await this.api.post('salvarParametroSistefoodDelivery', establishmentDice);
        return result.data;
    }


    async getTable(establishmentDice) {
        const result = await this.api.post('carregarParametroSistefoodMesa', establishmentDice);
        return result.data;
    }

    async saveTable(establishmentDice) {
        const result = await this.api.post('salvarParametroSistefoodMesa', establishmentDice);
        return result.data;
    }

    async getApp(establishmentDice) {
        const result = await this.api.post('carregarParametroSistefoodApp', establishmentDice);
        return result.data;
    }

    async saveApp(establishmentDice) {
        const result = await this.api.post('salvarParametroSistefoodApp', establishmentDice);
        return result.data;
    }

    async getMenu(establishmentDice) {
        const result = await this.api.post('carregarParametroSistefoodCardapio', establishmentDice);
        return result.data;
    }

    async saveMenu(establishmentDice) {
        const result = await this.api.post('salvarParametroSistefoodCardapio',establishmentDice);
        return result.data;
    }    

    async saveDfe(dfe) {
        const result = await this.api.post('salvarParametroSistefoodDfe',dfe);
        return result.data;
    }   

    async getDfe(dfe) {
        const result = await this.api.post('carregarParametroSistefoodDfe',dfe);
        return result.data;
    }   

    async getLoadingDfe(dfe) {
        const result = await this.apiLoadinfDfe.post('consultarCliente',dfe);
        return result.data;
    }   
}


export default ParametroServices;